import React, { useState, useEffect } from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import { useCurrency } from '../../hooks/useCurrency';
import { fallbackServices } from '../../data/fallbackData';
import { serviceTitle, priceRowName, priceRowFreeText } from '../../utils/serviceDisplay';
import { enrichServicesFromApi } from '../../utils/enrichServicesFromApi';
import api from '../../api';
import './PriceList.css';

const PriceList = ({ activeServiceSlug, onSelectSlug }) => {
  const { t, lang } = useTranslation();
  const { formatPrice, formatRange } = useCurrency();
  const [services, setServices] = useState(fallbackServices);

  useEffect(() => {
    api.get('/api/services')
      .then(res => {
        if (Array.isArray(res.data) && res.data.length > 0) {
          setServices(enrichServicesFromApi(res.data));
        }
      })
      .catch(() => {});
  }, []);

  const activeTab = Math.max(
    0,
    services.findIndex((s) => s.slug === activeServiceSlug)
  );

  const currentService = services[activeTab];
  const prices = Array.isArray(currentService?.prices) ? currentService.prices : [];
  const showRateDisclaimer = lang === 'ru' || lang === 'en';

  const renderPrice = (item) => {
    if (item.priceMinMnt > 0) {
      if (item.priceMaxMnt) {
        return formatRange(item.priceMinMnt, item.priceMaxMnt);
      }
      return formatPrice(item.priceMinMnt);
    }
    return priceRowFreeText(item, lang);
  };

  return (
    <section id="prices" className="section">
      <div className="container">
        <h2 className="section-title">{t('prices.title')}</h2>
        <p className="section-subtitle">{t('prices.subtitle')}</p>
        <div className="prices__tabs">
          {services.map((service, index) => (
            <button
              key={service.id || index}
              className={`prices__tab ${activeTab === index ? 'prices__tab--active' : ''}`}
              onClick={() => onSelectSlug?.(service.slug)}
            >
              <span className="prices__tab-icon">{service.icon || ''}</span>
              {serviceTitle(service, lang)}
            </button>
          ))}
        </div>
        <div className="prices__content">
          <div className="prices__table">
            <div className="prices__table-header">
              <span>{t('prices.headerWork')}</span>
              <span>{t('prices.headerPrice')}</span>
            </div>
            {prices.map((item, index) => (
              <div key={index} className="prices__table-row">
                <span className="prices__table-name">{priceRowName(item, lang)}</span>
                <span className="prices__table-price">{renderPrice(item)}</span>
              </div>
            ))}
          </div>
          <div className="prices__note">
            <p>{t('prices.note')}</p>
            {showRateDisclaimer && (
              <p className="prices__rate-note">{t('prices.rateDisclaimer')}</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PriceList;
